// extracted by css-extract-rspack-plugin
export default {"root":"Overlay-module__root___D5GSS"};